import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";

import useTheme from "hooks/useTheme";

import CloseIcon from "theme/icons/Close";

import TransactionAssetTransferDetailModal from "theme/modals/transactions/TransactionAssetTransferDetailModal";
import TransactionPayDetailModal from "theme/modals/transactions/TransactionPayDetailModal";

const TransactionInnerDetailModal = ({ isOpen, setIsOpen, modalInfo }) => {
	const { appLanguage, themeColor } = useTheme();

	const [transactionPayDetailModalIsOpen, setTransactionPayDetailModalIsOpen] = useState(false);
	const [transactionPayDetailModalInfo, setTransactionPayDetailModalInfo] = useState(false);

	const [transactionAssetTransferDetailModalIsOpen, setTransactionAssetTransferDetailModalIsOpen] = useState(false);
	const [transactionAssetTransferDetailModalInfo, setTransactionAssetTransferDetailModalInfo] = useState(false);

	return (
		<Transition appear show={isOpen} as={Fragment}>
			<Dialog as="div" className="relative z-10" onClose={() => setIsOpen(false)}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className={`fixed inset-0 ${themeColor?.bg} bg-opacity-30`} />
				</Transition.Child>

				<div className="fixed inset-0 overflow-y-auto">
					<div className="flex min-h-full items-center justify-center p-4 text-center">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<Dialog.Panel className="w-full max-w-sm transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
								<div className="flex flex-col w-full items-center space-y-3">
									<div className="flex w-full items-center justify-between">
										<p className={`text-md ${themeColor?.text}`}>Inner {appLanguage?.transactionDetails}</p>
										<CloseIcon
											className="w-4 cursor-pointer"
											fill={themeColor?.hex}
											onClick={() => setIsOpen(false)}
										/>
									</div>
									<div
										className={`flex flex-col w-full items-center justify-center space-y-3 rounded-lg p-3 border ${themeColor?.border}`}
									>
										{modalInfo?.["inner-txns"]?.length &&
											modalInfo["inner-txns"].map((innerTxn, index) =>
												innerTxn["tx-type"] === "axfer" ? (
													<div
														className="flex flex-col w-full items-start justify-start cursor-pointer"
														key={index}
														onClick={() => {
															setTransactionAssetTransferDetailModalInfo({
																...innerTxn,
																id: modalInfo?.id,
																sender: modalInfo?.sender,
															});
															setTransactionAssetTransferDetailModalIsOpen(true);
														}}
													>
														<div className="flex w-full items-center justify-between">
															<p className={`text-md ${themeColor?.text}`}>
																{innerTxn?.sender.slice(0, 5) +
																	"..." +
																	innerTxn?.sender.slice(-5)}
															</p>
															<div className="flex items-center space-x-2">
																<p className={`text-md ${themeColor?.text}`}>
																	{innerTxn["asset-transfer-transaction"]["amount"] / 1000000 +
																		" " +
																		innerTxn["asset-transfer-transaction"]["asset-unit-name"]}
																</p>
																<img
																	className={`w-4 h-4 ${themeColor?.text}`}
																	alt="asset"
																	loading="lazy"
																	src={`${process.env.REACT_APP_DAFFI_MAINNET_URL}/assets/image?assetID=${innerTxn["asset-transfer-transaction"]["asset-id"]}&width=30`}
																/>
															</div>
														</div>
													</div>
												) : (
													innerTxn["tx-type"] === "pay" && (
														<div
															className="flex flex-col w-full items-start justify-start cursor-pointer"
															key={index}
															onClick={() => {
																setTransactionPayDetailModalInfo({
																	...innerTxn,
																	id: modalInfo?.id,
																	sender: modalInfo?.sender,
																});
																setTransactionPayDetailModalIsOpen(true);
															}}
														>
															<div className="flex w-full items-center justify-between">
																<p className={`text-md ${themeColor?.text}`}>
																	{innerTxn?.sender.slice(0, 5) +
																		"..." +
																		innerTxn?.sender.slice(-5)}
																</p>
																<div className="flex items-center space-x-2">
																	<p className={`text-md ${themeColor?.text}`}>
																		{innerTxn["payment-transaction"]["amount"] / 1000000 +
																			" Algo"}
																	</p>
																	<img
																		className={`w-4 h-4 ${themeColor?.text}`}
																		alt="asset"
																		loading="lazy"
																		src={`${process.env.REACT_APP_DAFFI_MAINNET_URL}/assets/image?assetID=-1&width=30`}
																	/>
																</div>
															</div>
														</div>
													)
												)
											)}
									</div>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>

				<TransactionPayDetailModal
					isOpen={transactionPayDetailModalIsOpen}
					setIsOpen={setTransactionPayDetailModalIsOpen}
					modalInfo={transactionPayDetailModalInfo}
				/>

				<TransactionAssetTransferDetailModal
					isOpen={transactionAssetTransferDetailModalIsOpen}
					setIsOpen={setTransactionAssetTransferDetailModalIsOpen}
					modalInfo={transactionAssetTransferDetailModalInfo}
				/>
			</Dialog>
		</Transition>
	);
};

export default TransactionInnerDetailModal;
